// extracted by mini-css-extract-plugin
export default {"container":"SimpleTooltip_container__x6vYd","tooltip":"SimpleTooltip_tooltip__C8rd4"};